import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import { store } from '../../redux/store';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './index.css';
import SecureAxiosClient from '../../auth/secure_axios';
import ThreadItem from '../../threaditem';
import getConfig from '../../config';
import * as ChatActions from '../../redux/actions/chat';

class MyThreads extends Component {

    constructor(props) {
        super(props);

        this.state = { threads: [] };
    }

    componentDidMount() {
        this.getAllThreads();

        store.dispatch(ChatActions.setThemeImage({
            theme_image: null
        }));
    }

    getAllThreads() {
        let config = getConfig();
        let getThreadUrl = `${config.luigi.domain}${config.luigi.services.thread_by_user}`;
        console.log("Get Thread url:", getThreadUrl);
        new SecureAxiosClient().get(
            getThreadUrl,
            (responseCode, responseData) => {
                console.log("List of thread", responseData);
                this.setState({ threads: responseData });
            }
        )
    }

    render() {
        const threadLists = this.state.threads && this.state.threads
            .filter(thread => thread && !thread.is_archived)
            .map(thread => (
                <ThreadItem key={thread.id} thread={thread} isCreator={true} />
            ));
            console.log("ThreadList:", threadLists)
        return (
            <div className='page'>
                <p className="title">Your Threads <Link className='create-button' to="/create-thread">
                    Create
                </Link></p>

                <div className='thread-list'>
                    <ul>
                        {threadLists}
                    </ul>
                </div>
            </div>
        );
    }
}

MyThreads.propTypes = {
    user: PropTypes.object
  }
  
  const mapStateToProps = (state) => {
    return {
      user: state.user
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {};
  }
  
export default connect(mapStateToProps, mapDispatchToProps)(MyThreads);
